module.exports = __webpack_public_path__ + "img/forvaltningsomrader.cdd6cd19.jpg";